import React, {ReactElement} from "react";
import {Route} from "react-router-dom";
import Dependencies from "../../../utilities/Dependencies";
import Environment from "../../../services/interfaces/Environment";
import WorldPage from "../../../pages/chase/story/world/WorldPage";
import WorldSectionPage from "../../../pages/chase/story/world/section/WorldSectionPage";
import BestiaryPage from "../../../pages/chase/story/world/bestiary/BestiaryPage";
import BotanaryPage from "../../../pages/chase/story/world/botanary/BotanaryPage";
import GeographyPage from "../../../pages/chase/story/world/geography/GeographyPage";
import HistoryPage from "../../../pages/chase/story/world/history/HistoryPage";
import MagicPage from "../../../pages/chase/story/world/magic/MagicPage";
import LanguagesPage from "../../../pages/chase/story/world/languages/LanguagesPage";
import CommonLanguagePage from "../../../pages/chase/story/world/languages/common/CommonLanguagePage";
import PantheonPage from "../../../pages/chase/story/world/pantheon/PantheonPage";
import MythologyPage from "../../../pages/chase/story/world/mythology/MythologyPage";
import MythOfTheSixSistersPage from "../../../pages/chase/story/world/mythology/myths/MythOfTheSixSistersPage";
import MythOfTheSunAndMoonPage from "../../../pages/chase/story/world/mythology/myths/MythOfTheSunAndMoonPage";

class WorldRouter {

    public static getRoutes(deps: Dependencies, env: Environment): ReactElement {
        return (
            <>
                <Route path="world">
                    <Route index element={<WorldPage dependencies={deps} env={env}/>}/>
                    <Route path="bestiary">
                        <Route index element={<BestiaryPage dependencies={deps} env={env}/>}/>
                        <Route path=":subsection">
                            <Route index element={<WorldSectionPage dependencies={deps} env={env} section="bestiary"/>}/>
                            <Route path=":topic">
                                <Route index element={<WorldSectionPage dependencies={deps} env={env} section="bestiary"/>}/>
                            </Route>
                        </Route>
                    </Route>
                    <Route path="botanary">
                        <Route index element={<BotanaryPage dependencies={deps} env={env}/>}/>
                        <Route path=":subsection">
                            <Route index element={<WorldSectionPage dependencies={deps} env={env} section="botanary"/>}/>
                            <Route path=":topic">
                                <Route index element={<WorldSectionPage dependencies={deps} env={env} section="botanary"/>}/>
                            </Route>
                        </Route>
                    </Route>
                    <Route path="geography">
                        <Route index element={<GeographyPage dependencies={deps} env={env}/>}/>
                    </Route>
                    <Route path="history">
                        <Route index element={<HistoryPage dependencies={deps} env={env}/>}/>
                    </Route>
                    <Route path="magic">
                        <Route index element={<MagicPage dependencies={deps} env={env}/>}/>
                        <Route path=":subsection">
                            <Route index element={<WorldSectionPage dependencies={deps} env={env} section="magic"/>}/>
                            <Route path=":topic">
                                <Route index element={<WorldSectionPage dependencies={deps} env={env} section="magic"/>}/>
                            </Route>
                        </Route>
                    </Route>
                    <Route path="languages">
                        <Route index element={<LanguagesPage dependencies={deps} env={env}/>}/>
                        <Route path="common">
                            <Route index element={<CommonLanguagePage dependencies={deps} env={env}/>}/>
                        </Route>
                    </Route>
                    <Route path="pantheon">
                        <Route index element={<PantheonPage dependencies={deps} env={env}/>}/>
                    </Route>
                    <Route path="mythology">
                        <Route index element={<MythologyPage dependencies={deps} env={env}/>}/>
                        <Route path="myth-of-the-six-sisters" element={<MythOfTheSixSistersPage dependencies={deps} env={env}/>}/>
                        <Route path="myth-of-the-sun-and-moon" element={<MythOfTheSunAndMoonPage dependencies={deps} env={env}/>}/>
                    </Route>
                </Route>
            </>
        );
    }
}

export default WorldRouter;